import { render } from "./CompanyEditModal.vue?vue&type=template&id=bc5884b8"
import script from "./CompanyEditModal.vue?vue&type=script&lang=js"
export * from "./CompanyEditModal.vue?vue&type=script&lang=js"

import "./CompanyEditModal.vue?vue&type=style&index=0&id=bc5884b8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__